const PseudoLoginButton = () => (
  <div>
    <a className="btn btn-red team-pseudo-login-indicator">
      Pseudo login active
    </a>
  </div>
);

export default PseudoLoginButton;
